<script>

import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
//import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Branch Information",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "Branch Information",
            items: [],
            branch_info: [],
            channelpartnerlist: [],
            countryList: [],
            name: '',
            branch_code: '',
            channel_partner_id: '',
            email: '',
            email2: '',
            phone_no: '',
            address: '',
            city: '',
            postcode: '',
            state: '',
            country_id: '',
            operating_hour: '',
            status: '',
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY H:m:s')
            }
        },
        get_branch_by_id(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'branch/edit/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.branch_info = response.data;
                    this.name = this.branch_info[0].name;
                    this.branch_code = this.branch_info[0].branch_code;
                    this.channel_partner_id = this.branch_info[0].channel_partner_id;
                    this.email = this.branch_info[0].email;
                    this.email2 = this.branch_info[0].email2;
                    this.phone_no = this.branch_info[0].phone_no;
                    this.address = this.branch_info[0].address;
                    this.city = this.branch_info[0].city;
                    this.postcode = this.branch_info[0].postcode;
                    this.state = this.branch_info[0].state;
                    this.country_id = this.branch_info[0].country_id;
                    this.operating_hour = this.branch_info[0].operating_hour;               
                    this.status = this.branch_info[0].status;                
                    console.log(this.branch_info);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        update_branch(e)
        {
            this.ButtonSeen=true;
            e.preventDefault()
            
            const posting_ = {                
                name: this.name,
                branch_code: this.branch_code,
                channel_partner_id: this.channel_partner_id,
                email: this.email,
                email2: this.email2,
                phone_no: this.phone_no,
                operating_hour: this.operating_hour,
                address: this.address,
                city: this.city,
                postcode: this.postcode,
                state: this.state,
                country_id: this.country_id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'branch/update/'+this.$route.params.id, posting_)
            .then(response => {
                if (response) {
                  this.ButtonSeen=false; 
                  alert(response.data.msj); 
                  this.$router.push({ name: 'branch' });                      
                }
                else{
                    this.ButtonSeen=false;
                    console.log('tak ok');
                }
            });
        },

        //raw data----------------------------------------------------------
        get_channel_partner(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'channelpartner/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.channelpartnerlist = response.data;
                    console.log(this.channelpartnerlist);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_country(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'finco/raw_data_country')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.countryList = response.data;
                    console.log(this.countryList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        //raw data----------------------------------------------------------
    },

    components: {
        Layout,
        PageHeader, 
    },

    mounted() {     
        this.get_branch_by_id();   
        this.get_channel_partner();
        this.get_country();
           
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-7">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <h4><span class="badge badge-soft-primary badge-border">Branch : {{ name }}</span></h4>
            </div>
          </div>
          <div class="card-body">
            <div class="live-preview">
              <form @submit="update_branch">
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="branch_name" class="form-label">Name</label>
                  </div>
                  <div class="col-lg-9">
                    <input v-model='name' type="text" class="form-control" id="branch_name" />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="branch_code" class="form-label">Branch Code</label>
                  </div>
                  <div class="col-lg-9">
                    <input v-model='branch_code' type="text" class="form-control" id="branch_code" />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="channel_partner_id" class="form-label">Channel Partner</label>
                  </div>
                  <div class="col-lg-9">
                    <select v-model="channel_partner_id" class="form-select mb-3" arial-label="Default select example" placeholder="Please Select" required>
                        <option value="">--- Select Channel Partner ---</option>
                        <option v-for="(item, index) in channelpartnerlist" :key="index" :value="item.id" >
                            {{ item.name }}
                        </option>
                    </select>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="email" class="form-label">Email</label>
                  </div>
                  <div class="col-lg-9">
                    <input v-model='email' type="text" class="form-control" id="email" />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="email2" class="form-label">Alternative Email</label>
                  </div>
                  <div class="col-lg-9">
                    <input v-model='email2' type="text" class="form-control" id="email2" />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="phone_number" class="form-label">Phone Number</label>
                  </div>
                  <div class="col-lg-9">
                    <input v-model='phone_no' type="text" class="form-control" id="phone_number" />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="operating_hour" class="form-label">Operating Hour</label>
                  </div>
                  <div class="col-lg-9">
                    <input v-model='operating_hour' type="text" class="form-control" id="operating_hour" />
                  </div>
                </div>
                <hr class="my-4 text-muted">
                <div class="text-end col-lg-12">
                  <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button type="submit" class="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>        
      </div>

      <div class="col-xl-5">    
        <div class="card">
          <div class="card-header">
            <div class="d-flex">
              <h4><span class="badge badge-soft-primary badge-border"><i class="ri-map-pin-line align-middle me-1"></i>Branch Address</span></h4>
            </div>
          </div>
          <div class="card-body">
            <div>
                <div class="row g-3">
                    <div class="col-12">                        
                        <textarea v-model="address" rows="4" class="form-control" id="address" placeholder="Enter Company Address" ></textarea>
                    </div>
                    <div class="col-md-6">
                        <label for="zip" class="form-label">City</label>
                        <input v-model='city' type="text" class="form-control" id="city" placeholder="">
                    </div>
                    <div class="col-md-6">
                        <label for="zip" class="form-label">Postcode</label>
                        <input v-model='postcode' type="text" class="form-control" id="postcode" placeholder="">
                    </div>       
                    <div class="col-md-6">
                        <label for="zip" class="form-label">State</label>
                        <input v-model='state' type="text" class="form-control" id="state" placeholder="">
                    </div>
                    
                    <div class="col-md-6">
                        <label for="country" class="form-label">Country</label>
                        <select v-model="country_id" class="form-select mb-3" arial-label="Default select example" placeholder="Please Select" required>
                          <option value="">--- Select Country ---</option>
                          <option v-for="(item, index) in countryList" :key="index" :value="item.id" >
                              {{ item.name }}
                          </option>
                        </select>
                    </div>  
                </div>
                
                <hr class="my-4 text-muted">
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
